import React, { useState, useEffect } from "react";
import Select from "react-select";

const MultiselectAddNew = ({ form, field, label, options = [] }) => {
  const [tags, setTags] = useState(options);
  const [selectedItems, setSelectedItems] = useState([]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (field.value && Array.isArray(field.value)) {
      const selectedOptions = field.value.map((value) => {
        const existingTag = tags.find((tag) => tag.value === value);
        return existingTag || { label: value, value };
      });

      setSelectedItems(selectedOptions);

      setTags((prevTags) => [
        ...prevTags,
        ...selectedOptions.filter(
          (item) => !prevTags.some((t) => t.value === item.value)
        ),
      ]);
    }
  }, [field.value]);

  const handleChange = (items) => {
    setSelectedItems(items || []);
    form.setFieldValue(
      field.name,
      items ? items.map((item) => item.value) : []
    );
  };

  const handleCreateOption = () => {
    if (!inputValue.trim()) return;

    const exists = tags.find((tag) => tag.label === inputValue);
    if (exists) {
      setSelectedItems([...selectedItems, exists]);
      form.setFieldValue(
        field.name,
        [...selectedItems, exists].map((i) => i.value)
      );
      setInputValue("");
      return;
    }

    const newTag = {
      label: inputValue,
      value: inputValue,
    };

    setTags((prevTags) => [...prevTags, newTag]);
    const updatedSelected = [...selectedItems, newTag];
    setSelectedItems(updatedSelected);
    form.setFieldValue(
      field.name,
      updatedSelected.map((i) => i.value)
    );
    setInputValue("");
  };

  return (
    <div className="text-xs col-span-2">
      <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 text-white">
        {label}
      </label>
      <Select
        placeholder="تایپ کنید و Enter بزنید..."
        value={selectedItems}
        onChange={handleChange}
        onInputChange={(value, { action }) => {
          if (action !== "input-blur" && action !== "menu-close") {
            setInputValue(value);
          }
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" && inputValue) {
            e.preventDefault();
            handleCreateOption();
          }
        }}
        inputValue={inputValue}
        options={tags}
        isClearable
        isMulti
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        noOptionsMessage={() => "برای اضافه کردن، تایپ کنید و Enter بزنید"}
      />
      {form.errors[field.name] && (
        <span className="text-xs text-red-400">{form.errors[field.name]}</span>
      )}
    </div>
  );
};

export default MultiselectAddNew;
